// Borrowed from https://gist.github.com/hoschi/6538249ad079116840825e20c48f1690
// Note that reloading sagas has several issues/caveats to be aware of.
// See https://github.com/yelouafi/redux-saga/issues/22#issuecomment-218737951 for discussion.

import { type Store } from 'redux';
import { type SagaMiddleware, type Task } from 'redux-saga';
import { cancel, fork, select, take, type SelectEffect } from 'redux-saga/effects';

import { type ApplicationState } from '../store';
import rootSaga from './root-saga';

const sagas = [rootSaga];

const CANCEL_SAGAS_HMR = 'CANCEL_SAGAS_HMR';

/* 
This gives us a small amount of type safety when calling `select`.
To use it, pass the expected type into the generic argument.
You will get a type error if the expected type does not match the return type of the selector.
Then on the left side of the =, assign that same type to your variable. Like this:

```
  const storedOrders: Record<string, Order> = yield selectState<Record<string, Order>>(
    getOrdersData,
  );
```

This protects you against a future refactoring where someone changes the signature of `getOrdersData`.
If the signature changes, the right side of the = will get a compiler error.
The left side will not get a compiler error (thanks, yield) but you'll see a clear mismatch between the two types.
*/
export const selectState = <T>(selector: (s: ApplicationState) => T): SelectEffect =>
  select(selector);

// TODO: TS-ANY What is the correct type for this?
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createAbortableSaga = (saga: any) => {
  if (process.env.NODE_ENV === 'development') {
    return function* main() {
      const sagaTask: Task = yield fork(saga);

      yield take(CANCEL_SAGAS_HMR);
      yield cancel(sagaTask);
    };
  }

  return saga;
};

const SagaManager = {
  cancelSagas: (store: Store<ApplicationState>) => {
    store.dispatch({
      type: CANCEL_SAGAS_HMR,
    });
  },

  startSagas: (sagaMiddleware: SagaMiddleware) => {
    sagas.map(createAbortableSaga).forEach((saga) => sagaMiddleware.run(saga));
  },
};

export default SagaManager;
